import { cn } from '@/lib/cn';

type LogoProps = {
  variant?: 'full' | 'mark';
  className?: string;
  size?: number;
};

/** BingeBox mark — a single-colour blue box with a play glyph (spec §2). */
export function LogoMark({ size = 28, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      role="img"
      aria-label="BingeBox"
      className={className}
    >
      <rect x="3" y="3" width="26" height="26" rx="8" fill="#3B82F6" />
      <path d="M13 11.5 21 16l-8 4.5v-9Z" fill="#0A0A0F" />
    </svg>
  );
}

export function Logo({ variant = 'full', className, size = 28 }: LogoProps) {
  if (variant === 'mark') return <LogoMark size={size} className={className} />;
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <LogoMark size={size} />
      <span className="font-display text-lg font-extrabold tracking-tight text-ink">
        <span className="text-brand">Binge</span>Box
      </span>
    </span>
  );
}
